// extracted by mini-css-extract-plugin
export default {"desktopContent":"App_desktopContent__K+y8X","mobileContent":"App_mobileContent__bf9bw"};